(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mdfridayShortcode", [], factory);
	else if(typeof exports === 'object')
		exports["mdfridayShortcode"] = factory();
	else
		root["mdfridayShortcode"] = factory();
})(typeof self !== "undefined" ? self : this, () => {
return 